// features/premium/PreviewToggle.tsx — Free/Premium state preview switch.
//
// 1.23.00: purely local UI state — this component NEVER calls a service or
// writes anything. PremiumPage.tsx only renders it for an actual Pro
// subscriber (toggling between their real view and what a free member
// sees); it can never grant, simulate, or fake a real entitlement.
import styled from 'styled-components';

export type PreviewTier = 'free' | 'premium';
export interface PreviewToggleProps {
  value: PreviewTier;
  onChange: (tier: PreviewTier) => void;
}

const Seg = styled.div`
  display: inline-flex; gap: 2px; padding: 3px; border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
`;
const SegBtn = styled.button<{ $active: boolean }>`
  border: none; cursor: pointer; padding: 6px 14px; border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ theme, $active }) => ($active ? theme.color.onAccent : theme.color.textMuted)};
  background: ${({ theme, $active }) => ($active ? theme.color.accentCyan : 'transparent')};
`;

const ITEMS: { id: PreviewTier; label: string }[] = [
  { id: 'free', label: 'Free' },
  { id: 'premium', label: 'Premium' },
];

export function PreviewToggle({ value, onChange }: PreviewToggleProps) {
  return (
    <Seg role="group" aria-label="Preview tier">
      {ITEMS.map((it) => (
        <SegBtn key={it.id} type="button" $active={value === it.id}
          aria-pressed={value === it.id} onClick={() => onChange(it.id)}>
          {it.label}
        </SegBtn>
      ))}
    </Seg>
  );
}
